import { render, staticRenderFns } from "./ConfirmMail.vue?vue&type=template&id=d3276ab4"
import script from "./ConfirmMail.vue?vue&type=script&lang=ts"
export * from "./ConfirmMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseFullscreenDialog: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseFullscreenDialog.vue').default})
